import React from 'react';
import { Container, Typography, Box, Accordion, AccordionSummary, AccordionDetails, Stepper, Step, StepLabel, Button, Link, Grid, Divider } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import desktopBannerImage from '../assets/banner-desktop.png';
import tabletBannerImage from '../assets/banner-tablet.png';
import mobileBannerImage from '../assets/banner-mobile.png';
import twitterLogo from '../assets/x-logo.jpg';
import marketcapLogo from '../assets/coinmarketcap-logo.png';
import tiktokLogo from '../assets/tiktok-logo.png';
import telegramLogo from '../assets/telegram-logo.png';
import dexscreenerLogo from '../assets/dex-screener-logo.png';
import Header from '../components/Header/Header';

const HomePage: React.FC = () => {
    const handleMembersOnlyButtonClick = () => {
        const isDev = window.location.hostname.includes('dev');
        const url = isDev
            ? 'https://membersonly.devdwifd.com/home'
            : 'https://membersonly.dogwifdreads.com/home';

        window.open(url, '_blank');
    };


    const accordionSummaryStyles = {
        backgroundColor: '#000',
        color: '#fff',
        '& .MuiTypography-root': {
            color: '#fff',
        },
        '& .MuiSvgIcon-root': {
            color: '#fff',
        },
    };

    const stepLabelStyles = {
        '& .MuiStepLabel-label': {
            textAlign: 'center',
            width: '100%',
        },
        '& .MuiStepLabel-iconContainer': {
            justifyContent: 'center',
            display: 'flex',
        },
        '& .MuiStepIcon-root.Mui-completed': {
            color: 'limegreen',
        },
        '& .MuiStepIcon-root.Mui-active': {
            color: '#3599db',
        },
    }

    // this should total ~$4-5k
    const allMilestones = [
        // approximentally 5k
        { part: 1, target: 10000, value: 0, label: '🎰 $10K Market Cap', grouping: 'Bonding', wallet: 'N/A', type: 'Reincarnation', description: 'DWIFD launched and gaining traction', complete: true, active: false },
        { part: 1, target: 15000, value: 300, label: '📈 $15K Market Cap', grouping: 'Bonding', wallet: 'Dev', type: 'Dex', description: 'DEX listing fee paid — we go live!', complete: false, active: true },
        { part: 1, target: 23230, value: 115, label: '🎁 $23,230 Market Cap', grouping: 'Airdrop', wallet: 'Airdrop', type: 'Airdrop', description: 'Community Airdrop — Giveaway to 17 active members (~$7/ea)', complete: false, active: false },
        { part: 1, target: 30000, value: 300, label: '🔐 $30K Market Cap', grouping: 'Bonding', wallet: 'Lock', type: 'Locked', description: 'Lock Supply - 1% of supply will be locked for 2 months', complete: false, active: false },
        { part: 1, target: 40000, value: 200, label: '💎 250 Holders (~$15K-50K)', grouping: 'Holder', wallet: 'Airdrop', type: 'Airdrop', description: 'Holder Airdrop — Giveaway to 17 diamond handed holders (~$12/ea)', complete: false, active: false },
        { part: 1, target: 50000, value: 100, label: '🚀 $50K Market Cap', grouping: 'Bonding', wallet: 'Community', type: 'Boost', description: '10x DEX Boost - Buy 10x Dexscreener boost', complete: false, active: false },
        { part: 1, target: 60000, value: 600, label: '🔥 $60K Market Cap', grouping: 'Bonding', wallet: 'Burn', type: 'Burned', description: 'Burn Supply - 1% of supply will be burned', complete: false, active: false },
        { part: 1, target: 61818, value: 310, label: '❤️‍🔥 $61,818 Market Cap', grouping: 'Donation', wallet: 'Donation', type: 'Donation', description: 'Donation — 1st Donation to one our our charities', complete: false, active: false },
        { part: 1, target: 65000, value: 650, label: '🔐 $65K Market Cap', grouping: 'Bonding', wallet: 'Lock', type: 'Locked', description: 'Lock Supply - 1% of supply will be locked for 1 month', complete: false, active: false },
        { part: 1, target: 70000, value: 150, label: '🚀 $70K Market Cap', grouping: 'Bonding', wallet: 'Community', type: 'Boost', description: '30x DEX Boost - Buy 30x Dexscreener boost', complete: false, active: false },
        { part: 1, target: 72000, value: 500, label: '💎 500 Holders ($50K-100K)', grouping: 'Holder', wallet: 'Airdrop', type: 'Airdrop', description: 'Holder Airdrop — Giveaway to 23 diamond handed holders (~$22/ea)', complete: false, active: false },
        { part: 1, target: 75000, value: 760, label: '🔥 $75K Market Cap', grouping: 'Bonding', wallet: 'Burn', type: 'Burned', description: 'Burn Supply - 1% of supply will be burned', complete: false, active: false },
        { part: 1, target: 77777, value: 400, label: '❤️‍🔥 $77,777 Market Cap', grouping: 'Donation', wallet: 'Donation', type: 'Donation', description: 'Donation1 — 2nd Donation to one of our charities', complete: false, active: false },
        { part: 1, target: 85000, value: 300, label: '📢 $85K Market Cap', grouping: 'Bonding', wallet: 'Community', type: 'Ads', description: 'DEX Ads - Buy Ads for the coin to increase visibility', complete: false, active: false },
        { part: 1, target: 90000, value: 400, label: '🚀 $90K Market Cap', grouping: 'Bonding', wallet: 'Community', type: 'Boost', description: '50x DEX Boost - Buy 50x Dexscreener boost', complete: false, active: false },
        { part: 1, target: 97000, value: 0, label: '🎉 ~$97K Market Cap', grouping: 'Bonding', wallet: 'Burn', type: 'Burned', description: 'Coin bonding and migration to new LP', complete: false, active: false },
    
        // approximentally 12k
        { part: 2, target: 100000, value: 1000, label: '🔐 $100K Market Cap', grouping: 'Migrated', wallet: 'Lock', type: 'Locked', description: 'Lock Supply - 1% of supply will be locked for 3 months', complete: false, active: false },
        { part: 2, target: 111111, value: 250, label: '❤️‍🔥 $111K Market Cap', grouping: 'Donation', wallet: 'Donation', type: 'Donation', description: 'Donation - TBD', complete: false, active: false },
        { part: 2, target: 130000, value: 300, label: '📢 $130K Market Cap', grouping: 'Migrated', wallet: 'Community', type: 'Ads', description: 'DEX Ads Visibility - Buy Ads for the coin to increase visibility', complete: false, active: false },
        { part: 2, target: 150000, value: 560, label: '💎 1,000 Holders ($100K-$250K)', grouping: 'Holder', wallet: 'Airdrop', type: 'Airdrop', description: 'Holder Airdrop — Giveaway to 23 diamond handed holders (~$25/ea)', complete: false, active: false },
        { part: 2, target: 170000, value: 900, label: '🚀 $170K Market Cap', grouping: 'Migrated', wallet: 'Community', type: 'Boost', description: '100x Boost - Buy 100x DEX Screener boost', complete: false, active: false },
        { part: 2, target: 200000, value: 600, label: '🎁 $200K Market Cap', grouping: 'Airdrop', wallet: 'Airdrop', type: 'Airdrop', description: 'Community Airdrop — Giveaway to 25 active members (~$25/ea)', complete: false, active: false },
        { part: 2, target: 222222, value: 750, label: '❤️‍🔥 $222K Market Cap', grouping: 'Donation', wallet: 'Donation', type: 'Donation', description: 'Donation - TBD', complete: false, active: false },
        { part: 2, target: 250000, value: 900, label: '💎 2,000 Holders ($250K+)', grouping: 'Holder', wallet: 'Airdrop', type: 'Airdrop', description: 'Holder Airdrop — Giveaway to 30 diamond handed holders (~$30/ea)', complete: false, active: false },    
        { part: 2, target: 300000, value: 1000, label: '🎁 $300K Market Cap', grouping: 'Airdrop', wallet: 'Airdrop', type: 'Airdrop', description: 'Community Airdrop — Giveaway to 33 active members (~$30/ea)', complete: false, active: false },
        { part: 2, target: 333333, value: 1200, label: '❤️‍🔥 $333K Market Cap', grouping: 'Donation', wallet: 'Donation', type: 'Donation', description: 'Donation - TBD', complete: false, active: false },
        { part: 2, target: 444444, value: 4000, label: '🚀 $444K Market Cap', grouping: 'Migrated', wallet: 'Community', type: 'Boost', description: '500x Boost - Buy 500x DEX Screener boost', complete: false, active: false },
        { part: 2, target: 500000, value: 1800, label: '🎁 $500K Market Cap', grouping: 'Airdrop', wallet: 'Airdrop', type: 'Airdrop', description: 'Community Airdrop — Giveaway to 50 active members (~$35/ea)', complete: false, active: false },
        
        // approximentally 15k
        { part: 3, target: 555555, value: 1700, label: '❤️‍🔥 $555K Market Cap', grouping: 'Donation', wallet: 'Donation', type: 'Donation', description: 'Donation — TBD', complete: false, active: false },
        { part: 3, target: 777777, value: 2000, label: '❤️‍🔥 $777K Market Cap', grouping: 'Donation', wallet: 'Donation', type: 'Donation', description: 'Donation — TBD', complete: false, active: false },
        { part: 3, target: 1000000, value: 2050, label: '🎁 $1M Market Cap', grouping: 'Airdrop', wallet: 'Airdrop', type: 'Airdrop', description: 'Community Airdrop — TBD', complete: false, active: false },
        { part: 3, target: 1230000, value: 2500, label: '❤️‍🔥 $1.23M Market Cap', grouping: 'Donation', wallet: 'Donation', type: 'Donation', description: 'Donation - TBD', complete: false, active: false },
        { part: 3, target: 1500000, value: 2500, label: '🎁 $1.5M Market Cap', grouping: 'Airdrop', wallet: 'Airdrop', type: 'Airdrop', description: 'Community Airdrop — TBD', complete: false, active: false },
        { part: 3, target: 1700000, value: 3000, label: '❤️‍🔥 $1.7M Market Cap', grouping: 'Donation', wallet: 'Donation', type: 'Donation', description: 'Donation - TBD', complete: false, active: false },
        { part: 3, target: 2000000, value: 3000, label: '🎁 $2M Market Cap', grouping: 'Airdrop', wallet: 'Airdrop', type: 'Airdrop', description: 'Community Airdrop — TBD', complete: false, active: false },
        { part: 3, target: 2300000, value: 3500, label: '❤️‍🔥 $2.3M Market Cap', grouping: 'Donation', wallet: 'Donation', type: 'Donation', description: 'Donation - TBD', complete: false, active: false },
        { part: 3, target: 3000000, value: 3500, label: '🎁 $3M Market Cap', grouping: 'Airdrop', wallet: 'Airdrop', type: 'Airdrop', description: 'Community Airdrop — TBD', complete: false, active: false },
    
        // approximentally 17k
        { part: 4, target: 3000000, value: 10000, label: '🗳️ $3M+ Market Cap', grouping: 'Vote', wallet: 'TBD', type: 'TBD', description: 'Community votes on last $17,000 giveback', complete: false, active: false },
    ];

    // breaking the roadmap into parts
    const partOneMilestones = allMilestones.filter(m => m.part === 1);
    const partTwoMilestones = allMilestones.filter(m => m.part === 2);
    const partThreeMilestones = allMilestones.filter(m => m.part === 3);
    const partFourMilestones = allMilestones.filter(m => m.part === 4);

    const tokenomicsData = [
        { label: 'Total Supply', value: '1,000,000,000 (1B)' },
        { label: 'Contract Address', value: '8TKfTQ3ca21iCqbV8c9QqSrBWBEkB6qmquktT2C5pump' },
        { label: 'Trading Venue', value: 'PUMPSWAP' },
        { label: 'Pair Assets', value: 'DWIFD / SOL' }
    ];

    const communityAllocationPh1 = [
        { label: 'Donations Ph. 1', value: '1.7% - 17M', link: 'https://solscan.io/account/6PD5d8CKouWpd6eDoFDHFJvcw3FBjc3vTrhUELv2wQhs#portfolio' },
        { label: 'Airdrops Pt. 1', value: '1.7% - 17M', link: 'https://solscan.io/account/6yHAEMWJiTnaho25MtvGyTWr34kyQVom9GJsYKEKZPQ6#portfolio' },
        { label: 'Community Pt. 1', value: '1.2% - 12M', link: 'https://solscan.io/account/GQRRZpuv37f2Zeenvi713pS6iZmwpWeoLgBKEh9VdtQ8#portfolio' },
        { label: 'Airdrops Pt. 2', value: '1.7% - 17M', link: 'https://solscan.io/account/ANiKETU6QwXRe2HA6n73LgyJQqjN62hgAq7aukg7xoNd#portfolio' },
        { label: 'Locking Pt. 1', value: '2% - 20M', link: 'https://solscan.io/account/J8SYpB8GMCLmn77nH2rr24nryE2FQzvjo7up6XNBAkmk#portfolio' },
        { label: '1st Burn', value: '1% - 10M', link: 'https://solscan.io/account/Ba9WujQB7vikWaLRmDGmfbLETBcZFLBicMzTwho4Kbr7#portfolio' },
        { label: 'Locking Pt. 2', value: '1% - 10M', link: 'https://solscan.io/account/2PEgXc1nR1otEHoxhSzZCVtHpiPzfYSCzmsatX8dDm26#portfolio' },
        { label: '2nd Burn', value: '1% - 10M', link: 'https://solscan.io/account/2e3L7WDogsJuV4RLYCD8u1PXBUPDKN6QZ5fSo4f8dDfR#portfolio' },
    ];

    const communityAllocationPh2 = [
        { label: 'Donations Ph. 2', value: '1.8% - 18M', link: 'https://solscan.io/account/HPPoiRRq3gFRrDPR1haXxXE3Yg88bKv8UoUBZhyEheeg#portfolio' },
        { label: 'Airdrops Pt. 3', value: '1.3% - 13M', link: 'https://solscan.io/account/3HrT4fWh8F2cwip1FqbuHGShJnRKY9LZ3w8yHCh9Czw8#portfolio' },
        { label: 'Community Pt. 2', value: '1.6% - 16M', link: 'https://solscan.io/account/6Ku3B47pWdy1L3hnwdPjydE9J4qup9c844YWe8ssNpe#portfolio' },
        { label: 'Airdrops Pt. 4', value: '1% - 10M', link: 'https://solscan.io/account/9ERVSE9VGXJ4BpE6bkeBZ11KFR8UjHgJEFRzVT4gxp5H#portfolio' },
    ];

    return (
        <Container maxWidth={false} disableGutters>
            
            {/* Banner Section */}
            <Header />

            {/* Banner Section */}
            <Box
            sx={{
                width: '100%',
                height: {
                    xs: '75vh', // 40% of viewport height on mobile
                    sm: '50vh', // slightly taller on tablets
                    md: '80vh', // even taller on desktop
                },
                backgroundImage: {
                xs: `url(${mobileBannerImage})`, // vertical image
                sm: `url(${tabletBannerImage})`, // horizontal image
                md: `url(${desktopBannerImage})`,
                },
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                backgroundRepeat: 'no-repeat',
            }}
            />

            {/* Links Section */}
            <Container maxWidth="md" sx={{ my: 4 }}>
                <Grid container spacing={2} sx={{ mt: 2 }}>
                    <Grid item xs={2.4} textAlign="center">
                        <Link href="https://t.me/dwifdsol" target="_blank" sx={{ textDecoration: 'none' }}>
                            <img src={telegramLogo} alt="Telegram" style={{ maxWidth: '60px', maxHeight: '60px' }} />
                        </Link>
                    </Grid>
                    <Grid item xs={2.4} textAlign="center" >
                        <Link href="https://dex.coinmarketcap.com/token/solana/8TKfTQ3ca21iCqbV8c9QqSrBWBEkB6qmquktT2C5pump/" target="_blank" sx={{ textDecoration: 'none' }}>
                            <img src={marketcapLogo} alt="Market Cap" style={{ maxWidth: '60px', maxHeight: '60px' }} />
                        </Link>
                    </Grid>
                    <Grid item xs={2.4} textAlign="center">
                        <Link href="https://dexscreener.com/solana/jp2e4mlynuce6y2yp8talsjfrnejcdwt3jvtdmfgwqd" target="_blank" sx={{ textDecoration: 'none' }}>
                            <img src={dexscreenerLogo} alt="Dex Screener" style={{ maxWidth: '60px', maxHeight: '60px' }} />
                        </Link>
                    </Grid>
                    <Grid item xs={2.4} textAlign="center">
                        <Link href="https://x.com/dogwifdreadz" target="_blank" sx={{ textDecoration: 'none' }}>
                            <img src={twitterLogo} alt="X" style={{ maxWidth: '60px', maxHeight: '60px' }} />
                        </Link>
                    </Grid>
                    <Grid item xs={2.4} textAlign="center">
                        <Link href="https://x.com/dogwifdreadz" target="_blank" sx={{ textDecoration: 'none' }}>
                            <img src={tiktokLogo} alt="Tik Tok" style={{ maxWidth: '60px', maxHeight: '60px' }} />
                        </Link>
                    </Grid>

                </Grid>
            </Container>

            {/* About & Story Time */}
            <Box sx={{ py: 6, px: 4, backgroundColor: 'rgba(0, 0, 0, 1)', color: '#fff' }}>
                <Container maxWidth="md" sx={{ textAlign: 'center' }}>
                    <Typography variant="h1" gutterBottom>Legends Never Die</Typography>
                    <Typography variant="body1" paragraph>
                        <strong>Born from the ashes of meme culture and SoundCloud rebellion</strong>, <em>Dogwifdreads ($DWIFD)</em> is more than a coin — it’s a movement. A Shiba Inu with XXXTentacion’s energy and iconic dreads, DWIFD channels raw emotion, chaos, and purpose into crypto.
                    </Typography>

                    <Typography variant="body1" paragraph>
                        It all started with <a style={{color: '#d4920f'}} href="https://pump.fun/coin/2Frwi7zdMA5uQQHYiJ5tcMaBnPh874mXHquniQbMpump">NonchalantDreadHead</a>, a memecoin that reached a <strong>2M market cap</strong> and hit nearly<strong>$10M in volume in just a few hours</strong> — then rugged. The community was left stunned, but not broken. A group of believers came together to keep the nonchalant vibe alive. From that spark, <strong>Dogwifdreads was born</strong>, rising like a phoenix from XXX’s legacy.
                    </Typography>

                    <Typography variant="body1" paragraph>
                        After launch, the original dev sold out. Enter <a style={{color: '#d4920f'}} href="https://www.tiktok.com/@ctohub88?_t=ZT-90agbow6Woh&_r=1">Johnathan’sCTO</a>, who picked up the reins and rocketed DWIFD to an <strong>$80K market cap</strong> in hours. TikTok streams lit up with <a style={{color: '#d4920f'}} href="https://www.tiktok.com/@calvocryptto?_t=ZT-90agLc8wkLv&_r=1">Crypto Calvo</a>, <a style={{color: '#d4920f'}} href="https://www.tiktok.com/@cocoacatdev?_t=ZT-90agREmrJ9x&_r=1">UPD | COCOADEV</a>, <a style={{color: '#d4920f'}} href="https://www.tiktok.com/@onlypumpz?_t=ZT-90agHsGcsj0&_r=1">Only Pumpz</a>, and <a style={{color: '#d4920f'}} href="https://www.tiktok.com/@cryptocldhy?_t=ZT-90afx9cgiTd&_r=1">CRYPTOCLDHY</a> pushing the coin live. The hype was real.
                    </Typography>

                    <Typography variant="body1" paragraph>
                        Then came the chaos. At <strong>$50–60K</strong>, sell-offs and finger-pointing hit hard. Calvo and UPD told everyone to pull out — then they vanished. The wick was brutal. But the community didn’t flinch. <strong>We rallied. We re-built.</strong>
                    </Typography>

                    <Typography variant="body1" paragraph>
                        In honor of XXXTentacion’s debut album <em>17</em>, the team is allocating <strong>17% of funds to the community</strong> — for Airdrops, Donations, Dex boosts, Ads, and burns at key milestones. Plus, <strong>3% of the supply</strong> is scheduled to lockup for 3 months from point the milestone is met during Phase 1. During Phase 2, Members Only will vote on how to spend the 30M tokens as they unlock.
                    </Typography>

                    <Typography variant="body1" paragraph>
                        This isn’t just about memes. <strong>It’s about meaning.</strong> We’re building a community in XXX’s name, <strong>supporting nonprofits</strong>, and building a real community built on <strong>Trust & Transparency</strong>. DWIFD is for the nonchalant dread heads, the misfits, the dreamers — and everyone who believes in second chances.
                    </Typography>

                    <Typography variant="body1" paragraph>
                        <strong>Let’s eat.</strong>
                    </Typography>
                </Container>
            </Box>

            {/* Roadmap Section */}
            <Box sx={{ py: 6, backgroundColor: '#d4920f', color: '#000' }}>
                <Container maxWidth="md">
                    <Typography variant="h1" gutterBottom textAlign="center">📍 Roadmap</Typography>

                    <Typography variant="h5" gutterBottom textAlign="center">Phase 1: Build Trust</Typography>
                    <Typography variant="h4" gutterBottom textAlign="center">💸 Giveaway $17,000 of $50K</Typography>

                    {/* Part 1 */}
                    <Accordion sx={{ backgroundColor: 'rgb(105, 72, 6, 0.99)' }}>
                        <AccordionSummary expandIcon={<ExpandMoreIcon sx={{ color: '#fff' }} />} sx={accordionSummaryStyles}>
                            <Typography variant="h5">🤑 Pt. 1: Coin Bonding - $5K</Typography>
                        </AccordionSummary>
                        <AccordionDetails sx={{ backgroundColor: 'rgba(212, 147, 17, 0.8)', borderRadius: 2 }}>
                            <Stepper orientation="vertical" activeStep={1}>
                                {partOneMilestones.map((step, index) => (
                                    <Step key={index} completed={step.complete} active={step.active}>
                                        <StepLabel
                                            StepIconComponent={undefined}
                                            sx={stepLabelStyles}
                                        >
                                            <Typography variant="h6">{step.label}</Typography>
                                            <Typography variant='body1'>
                                                <span style={{color:'#ccc'}}>
                                                {new Intl.NumberFormat('en-US', {
                                                    style: 'currency',
                                                    currency: 'USD',
                                                }).format(step.value)} Value
                                                </span>
                                            </Typography>
                                            <Typography variant="body1">{step.description}</Typography>
                                        </StepLabel>
                                    </Step>
                                ))}
                            </Stepper>
                        </AccordionDetails>
                    </Accordion>

                    {/* Part 2 */}
                    <Accordion sx={{ backgroundColor: 'rgb(105, 72, 6, 0.99)' }}>
                        <AccordionSummary expandIcon={<ExpandMoreIcon sx={{ color: '#fff' }} />} sx={accordionSummaryStyles}>
                            <Typography variant="h5">🚀 Pt. 2: Post-migration - $12K</Typography>
                        </AccordionSummary>
                        <AccordionDetails sx={{ backgroundColor: 'rgba(212, 147, 17, 0.8)', borderRadius: 2 }}>
                            <Stepper orientation="vertical" activeStep={1}>
                                {partTwoMilestones.map((step, index) => (
                                    <Step key={index} completed={step.complete} active={step.active}>
                                        <StepLabel
                                            StepIconComponent={undefined}
                                            sx={stepLabelStyles}
                                        >
                                            <Typography variant="h6">{step.label}</Typography>
                                            <Typography variant="body1">{step.description}</Typography>
                                        </StepLabel>
                                    </Step>
                                ))}
                            </Stepper>
                        </AccordionDetails>
                    </Accordion>

                    <Divider sx={{ my: 4, borderColor: '#000' }} />
                    <Typography variant="h5" gutterBottom textAlign="center">Phase 2: Complete Mission</Typography>
                    <Typography variant="h4" gutterBottom textAlign="center">🎯 Give X's Full $50,000 Back</Typography>

                    {/* Part 3 */}
                    <Accordion sx={{ backgroundColor: 'rgb(105, 72, 6, 0.6)' }}>
                        <AccordionSummary expandIcon={<ExpandMoreIcon sx={{ color: '#fff' }} />} sx={accordionSummaryStyles}>
                            <Typography variant="h5">🔥 Pt. 3: Community Eats - $33K</Typography>
                        </AccordionSummary>
                        <AccordionDetails sx={{ backgroundColor: 'rgba(212, 147, 17, 0.8)', borderRadius: 2 }}>
                            <Stepper orientation="vertical" activeStep={1}>
                                {partThreeMilestones.map((step, index) => (
                                    <Step key={index} completed={step.complete} active={step.active}>
                                        <StepLabel
                                            StepIconComponent={undefined}
                                            sx={stepLabelStyles}
                                        >
                                            <Typography variant="h6">{step.label}</Typography>
                                            <Typography variant="body1">{step.description}</Typography>
                                        </StepLabel>
                                    </Step>
                                ))}
                            </Stepper>
                        </AccordionDetails>
                    </Accordion>

                    {/* Part 4 */}
                    <Accordion sx={{ backgroundColor: 'rgb(105, 72, 6, 0.6)' }}>
                        <AccordionSummary expandIcon={<ExpandMoreIcon sx={{ color: '#fff' }} />} sx={accordionSummaryStyles}>
                            <Typography variant="h5">🤝 Pt. 4: Team Decisions - 50M Tokens Left</Typography>
                        </AccordionSummary>
                        <AccordionDetails sx={{ backgroundColor: 'rgba(212, 147, 17, 0.8)', borderRadius: 2 }}>
                            <Stepper orientation="vertical" activeStep={1}>
                                {partFourMilestones.map((step, index) => (
                                    <Step key={index} completed={step.complete} active={step.active}>
                                        <StepLabel
                                            StepIconComponent={undefined}
                                            sx={stepLabelStyles}
                                        >
                                            <Typography variant="h6">{step.label}</Typography>
                                            <Typography variant="body1">{step.description}</Typography>
                                        </StepLabel>
                                    </Step>
                                ))}
                            </Stepper>
                        </AccordionDetails>
                    </Accordion>
                </Container>
            </Box>


            {/* Tokenomics Section */}
            <Box sx={{ py: 6, px: 4, backgroundColor: '#000', color: '#fff' }}>
                <Container maxWidth="md">
                    <Typography variant="h2" gutterBottom textAlign="center">📊 Tokenomics</Typography>
                                
                    <Grid container spacing={2} sx={{ textAlign: 'center' }}>
                        {tokenomicsData.map((item, index) => (
                            <Grid item xs={6} key={index}>
                                <Typography variant="subtitle1" sx={{ fontWeight: 'bold' }}>{item.label}</Typography>
                                <Typography
                                    variant="body1"
                                    sx={{
                                        wordBreak: 'break-word', // or 'break-all'
                                        overflowWrap: 'break-word',
                                    }}
                                    >
                                    {item.value}
                                </Typography>
                            </Grid>
                        ))}
                    </Grid>

                    <Divider sx={{ my: 4, borderColor: '#d4920f' }} />

                    <Typography variant="h4" gutterBottom textAlign="center">📅 Community Allocation (17%)</Typography>

                    <Typography variant="h5" gutterBottom textAlign="center">Phase 1</Typography>
                    <Grid container spacing={2} sx={{ textAlign: 'center' }}>
                        {communityAllocationPh1.map((item, index) => (
                            <Grid item xs={6} key={index}>
                                <Typography variant="subtitle1" sx={{ fontWeight: 'bold' }}>{item.label}</Typography>
                                <Typography variant="body1">{item.value}</Typography>
                                <Link href={item.link} target="_blank">View on Solscan</Link>
                            </Grid>
                        ))}
                    </Grid>

                    <Divider sx={{ my: 4, borderColor: '#d4920f' }} />

                    <Typography variant="h5" gutterBottom textAlign="center">Phase 2</Typography>
                    <Grid container spacing={2} sx={{ textAlign: 'center' }}>
                        {communityAllocationPh2.map((item, index) => (
                            <Grid item xs={6} key={index}>
                                <Typography variant="subtitle1" sx={{ fontWeight: 'bold' }}>{item.label}</Typography>
                                <Typography variant="body1">{item.value}</Typography>
                                <Link href="https://solscan.io/account/..." target="_blank">View on Solscan</Link>
                            </Grid>
                        ))}
                    </Grid>


                </Container>
            </Box>

            {/* Promo Section */}
            <Box sx={{ py: 6, textAlign: 'center', backgroundColor: '#d4920f' }}>
                <Container maxWidth="md" sx={{ textAlign: 'center' }}>
                    <Typography variant="h5" gutterBottom>🏛️ Members Only</Typography>
                    <Typography variant="body1" paragraph>Inspired by XXX's Members Only Club, we have created Members Only to build a real community that engagues with the team and helps shape the direction of the coin. Join now for complete transparency in the spending, increase your chances for Airdrops, participate in votes, and help us build out the community.</Typography>
                    <br/>
                    <Button
                        component={Link}
                        onClick={handleMembersOnlyButtonClick}
                        sx={{
                            backgroundColor: '#000',
                            color: '#fff',
                            '&:hover': {
                                backgroundColor: '#fff',
                                color: '#d1930d',
                            },
                        }}
                    >
                        Join Members Only
                    </Button>
                </Container>
            </Box>

            {/* Footer */}
            <Box sx={{ py: 4, textAlign: 'center', backgroundColor: '#000', color: '#aaa' }}>
                <Typography variant="caption">© 2025 DWIFD. Not financial advice. I'm just a dog, dawg... Get wif it!</Typography>
            </Box>
        </Container>
    );
};

export default HomePage;